import { ApplicationInsights } from "@microsoft/applicationinsights-web";

export default (instrumentationKey: string): void => {
  const appInsights = new ApplicationInsights({
    config: {
      instrumentationKey: instrumentationKey,
      enableAutoRouteTracking: true, // optional
    },
  });

  if (instrumentationKey && instrumentationKey !== "") {
    // appInsights.downloadAndSetup({ instrumentationKey });
    appInsights.loadAppInsights();

    window.onerror = (message, fileName, lineNumber, colNumber, error) => {
      let data: any;

      if (typeof error !== "undefined" && error !== null) {
        data = {
          message,
          stack: JSON.stringify(error.stack),
          error: JSON.stringify(error),
          fileName,
          lineNumber,
        };
      } else {
        data = {
          message,
          fileName,
          lineNumber,
        };
      }
      // AppInsights.trackEvent('Javascript exception', data);
      appInsights.trackEvent({
        name: "Javascript exception",
        properties: data,
      });

      // returning false will not disable possible further error handling
      return false;
    };
  }
};
